module.exports = __webpack_public_path__ + "img/no-image.67015b05.png";